export default __webpack_public_path__ + "static/media/36I-102636_-17088_0.c583082b.jpg";